import {UI, styleRuleCustom, styleRuleInherit, styleRule} from "../../stem-core/src/ui/UI";
import {App} from "../App";
import {GlobalStyleSheet} from "../theme/GlobalStyleSheet.jsx";
import {Route, Router} from "../../stem-core/src/ui/Router";
import {iFrameConnection} from "../services/IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "../services/IFrameState";
import {LOGIN_URL, LOGIN_WITH_EMAIL_CODE_URL} from "../Constants";
import {authService} from "../../client/connection/Services";

import {Theme} from "../../stem-core/src/ui/UI";
import {unwrapArray} from "../../stem-core/src/base/Utils";
import {PageTitleManager} from "../../stem-core/src/base/PageTitleManager";
import {
    ADDRESS_PANEL_URL,
    CTA_URL,
    FUNCTIONALITY_NOT_ENABLED_URL,
    INLINE_DONATION_URLS,
    INLINE_EDIT_DONATION_URLS,
    INLINE_EDIT_SUBSCRIPTION_URLS,
    INLINE_GIFT_SUBSCRIPTION_URLS,
    INLINE_NEWSLETTER_URLS,
    INLINE_SHOP_URLS,
    INLINE_SUBSCRIPTION_URLS,
    INLINE_USER_DASHBOARD_URLS,
    PAYMENT_DETAILS_PANEL_URL,
    PAYMENT_FAILED_PANEL_URL,
    SUBSCRIPTION_PLAN_PANEL_URL
} from "./PanelConstants";
import {BlinkGlobal, isDeepEqual, isSmallScreen} from "../Utils";

import {
    GATE_TYPE,
    IFRAME_APP_TYPE,
    PANEL_TYPE,
    SOCIAL_APPS
} from "../../blink-sdk/Constants";
import {Image} from "../../stem-core/src/ui/UIPrimitives";
import {supportsPassiveEvents} from "../../blink-sdk/utils/Utils";
import {iFrameMerchantService} from "../services/IframeMerchantService";
import {AuthPanelPage} from "./auth/AuthPanelPage.jsx";
import {SubscribeAuthPage} from "./auth/SubscribeAuthPage.jsx";
import {DonationAuthPage} from "./auth/DonationAuthPage.jsx";
import {CDSAuthPage} from "blinkpay/panel/auth/CDSAuthPage.jsx";
import {EmailCodeConfirmationPanel} from "./auth/EmailCodeConfirmationPanel.jsx";
import {DonatePanel} from "./pages/panels/donation/DonatePanel";
import {PaymentMethodPanel} from "./pages/panels/payment-method/PaymentMethodPanel";
import {DonationSuccessPanel} from "./pages/panels/donation/DonationSuccessPanel";
import {EditDonationPanel} from "./pages/panels/donation/edit-donation/EditDonationPanel";
import {CancelDonationPanel} from "./pages/panels/donation/edit-donation/CancelDonationPanel";
import {DonationCanceledPanel} from "./pages/panels/donation/edit-donation/DonationCanceledPanel";
import {EditDonationSuccessPanel} from "./pages/panels/donation/edit-donation/EditDonationSuccessPanel";
import {SubscriptionPlanPanel} from "./pages/panels/subscribe/SubscriptionPlanPanel";
import {SubscribeReviewOrderPanel} from "./pages/panels/subscribe/SubscribeReviewOrderPanel";
import {SubscribeSuccessPanel} from "./pages/panels/subscribe/SubscribeSuccessPanel.jsx";
import {EditSubscriptionCancelPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelPanel";
import {EditSubscriptionCancelSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelSuccessPanel";
import {PaymentAndDonationPanel} from "./pages/panels/donation/PaymentAndDonationPanel";
import {initializeTheme} from "../theme/StyleConstants.js";
import {NewsletterSubscribePanel} from "./pages/panels/newsletter/NewsletterSubscribePanel";
import {NewsletterSubscribeSuccessPanel} from "./pages/panels/newsletter/NewsletterSubscribeSuccessPanel";
import {InlineUserDashboard} from "./pages/inline-user-dashboard/InlineUserDashboard";
import {InlineUserDashboardRemoveCardPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveCardPanel";
import {InlineUserDashboardChangeEmailCodeConfirmPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardChangeEmailCodeConfirmPanel";
import {AddressPanel} from "./pages/panels/address/AddressPanel";
import {InlineUserDashboardRemoveAddressPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveAddressPanel";
import {InlineUserDashboardAddressInUsePanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardAddressInUsePanel";
import {EditSubscriptionConfirmPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionConfirmPanel.jsx";
import {englishTranslationMap} from "../Messages";
import {apiClient} from "../../client/connection/BlinkApiClient.js";
import {GlobalState} from "../../stem-core/src/state/State";
import {iFrameAuthService, shiftToMerchantToken} from "../services/IFrameAuthService";
import {EditSubscriptionSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionSuccessPanel.jsx";
import {FunctionalityNotEnabledPanel} from "./pages/panels/FunctionalityNotEnabledPanel";
import {CustomContentPanel} from "./pages/panels/CustomContentPanel.jsx";
import {merchantStyleRule} from "./Security";
import {PanelCollapsed} from "./pages/panels/PanelCollapsed";
import {addScrimListeners} from "../widget/WidgetAnimation";
import {GiftSubscriptionDetailsPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionDetailsPanel.jsx";
import {GiftSubscriptionSuccessPanel} from "./pages/panels/subscribe/gift-subscriptions/GiftSubscriptionSuccessPanel";
import {PaymentFailedPanel} from "./pages/panels/payment-method/PaymentFailedPanel";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../blink-sdk/utils/AnalyticsClient";
import {initializeFlows} from "./flows/FlowState.js";
import {ShopPanel} from "./pages/shop/ShopPanel";
import {ShopReviewOrderPanel} from "./pages/shop/ShopReviewOrderPanel.jsx";
import {ShopOrderSuccessPanel} from "./pages/shop/ShopOrderSuccessPanel.jsx";
import {PanelToastStyle, Toast} from "../ui/Toast.jsx";
import {ManageSubscriptionPanel} from "./pages/inline-user-dashboard/tabs/InlineUserDashboardSubscriptionTab.jsx";
import {Flow} from "./flows/Flow.js";


export class PanelAppGlobalStyleSheet extends GlobalStyleSheet {
    @styleRuleCustom({selector: "body"})
    body = {
        margin: 0,
        userSelect: "text",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        " *": {
            userSelect: () => isSmallScreen() ? "none" : "auto",
            "-webkit-tap-highlight-color": "transparent",
        },
        position: "absolute",
    };

    @styleRule
    panelApp = {
        overflow: "hidden !important",
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        background: "transparent",
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT,
        maxWidth: "100%",
        maxHeight: "100%"
    };

    @merchantStyleRule
    popupGate = {
        margin: "auto",
    };

    @styleRuleInherit
    a = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleCustom({selector: "b"})
    b = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleInherit
    allInputs = {
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
    };
}

export class PanelApp extends App {
    merchantFonts = [];
    sizeStyle = {};


    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        const styleSheet = PanelAppGlobalStyleSheet.getInstance();

        attr.addClass(styleSheet.panelApp);

        if (iFrameState.gateType === GATE_TYPE.popup || iFrameState.gateType == GATE_TYPE.popupGate) {
            attr.addClass(styleSheet.popupGate);
        }

        attr.setStyle(this.sizeStyle);
    }

    applyMerchantTheme() {
        this.addMerchantFonts();
        // TODO @style we probably only want to add the new merchant fields
        initializeTheme(iFrameState.theme);
    }

    applyMerchantMessages() {
        for (const [key, value] of Object.entries(iFrameState.messages)) {
            englishTranslationMap.set(key, value);
        }
    }

    applyMerchantConfig() {
        this.applyMerchantTheme(); // TODO is this only limited to the scope of this app? These are Global
        this.applyMerchantMessages();
        Theme.Global.updateStyleSheets();
        // TODO This should probably be done in initializeTheme()
        Theme.Global.register(Toast, PanelToastStyle);
    }

    constructor(...args) {
        super(...args);

        BlinkGlobal.appInstance = this;

        const route = iFrameState.handleFlowInline() ? PANEL_TYPE.empty : CTA_URL;
        this.initRouter(route);

        this.applyMerchantConfig();
    }

    initRouter(initialPage) {
        // The router in this app shouldn't alter the browser history.
        Router.useLocalHistory = true;
        Router.localHistory = ["/" + initialPage];

        // TODO @flow2 probably remove this shit, it doesn't make any sense
        Router.changeToCustomPanel = function() {
            // The panel rendered will use iFrameState.iframeParams.panelContent. That value has some defaults depending on the
            // panel type (PANEL_CONTENT[panelType]). Look up the "composePanelOptions" method in
            // CreatePanelDefaultOptions.
            Router.changeURL(CTA_URL);
        }

        Router.globalSetURL = function(urlParts) {
            urlParts = unwrapArray(urlParts);
            const page = this.getPageToRender(urlParts);

            if (!page) return;

            const activePage = this.getActive();
            const app = BlinkGlobal.appInstance;

            if (page instanceof PanelCollapsed) {
                app.setStyle("pointerEvents", "none");
            } else {
                app.setStyle("pointerEvents", "initial");
            }

            if (activePage !== page) {
                app.applyMerchantConfig(); // Just for good measure. @cleanup it seems to be applied by a later listener.
                if (activePage) {
                    activePage.dispatch("urlExit");
                }
                this.setActive(page);
                page.dispatch("urlEnter");

                const urlRoute = urlParts.join("/");
                if (urlRoute !== "empty") {
                    if (iFrameState.gateType === GATE_TYPE.popup || iFrameState.gateType == GATE_TYPE.popupGate) {
                        dispatchAnalyticsEvent(AnalyticsEventType.POPUP_PAGE_CHANGE, {
                            page: urlRoute,
                            flowType: iFrameState.panelType
                        });
                    }
                    iFrameConnection.sendToSDK(IFrameMessages.ROUTE_CHANGE, {route: urlRoute});
                }
            } else {
                page.dispatch("urlReload");
            }

            // When you use blinkaction, this first route gets received in the wallet module when the flow is already
            // active and the actual route is the donation one. It seems like the user exited the flow but it's not
            // the case.

            if (page && page.pageTitle) {
                PageTitleManager.setTitle(page.pageTitle);
            }

            this.dispatch("change", urlParts, page, activePage);

            if (iFrameState.iframeParams.inlineFlow) {
                iFrameConnection.sendToSDK(IFrameMessages.SCROLL_IFRAME_TOP, {windowScroll: {top: 0}});
            }
        }
    }

    addMerchantFonts() {
        const styleElement = document.createElement("style");
        for (const font of iFrameState.fonts) {
            // TODO @cleanup This is stupid
            if (!this.merchantFonts.find(f => isDeepEqual(f, font))) {
                const {family, style, src, weight, unicodeRange} = font;
                styleElement.appendChild(document.createTextNode(`
                @font-face{
                    font-family: ${family};
                    src: ${src};
                    ${style ? `font-style: ${style};` : ""}
                    ${weight ? `font-weight: ${weight};` : ""}
                    ${unicodeRange ? `unicode-range: ${unicodeRange}; ` : ""}
                }`));
                this.merchantFonts.push(font);
            }
        }
        if (styleElement.innerHTML.length) {
            document.head.appendChild(styleElement);
        }
    }

    static initializeGlobalStyle() {
        PanelAppGlobalStyleSheet.initialize();
    }

    static addWsListener(streamName) {
        apiClient.addWebsocketListener(streamName, async event => {
            if (event.type === "logout") {
                if (iFrameAuthService.merchantToken) {
                    shiftToMerchantToken();
                } else {
                    authService.clearCurrentInfo();
                }
            } else {
                GlobalState.applyEvent(event);
            }
        });
    }

    getRouterOptions() {
        let routerStyle = {
            [GATE_TYPE.popup]: {
                height: "100%",
                width: "100%",
                display: "flex",
                overflow: "auto",
                justifyContent: "center",
                alignItems: "center",
            },
            [GATE_TYPE.banner]: {
                width: "100%",
            },
            [GATE_TYPE.cover]: {
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            // It actually works when gateType is null
            "null": {
                width: "100%",
                display: "flex",
                overflow: "auto",
                justifyContent: "center",
            }
        }

        return {style: routerStyle[iFrameState.gateType]};
    }

    // TODO @cleanup delete this?
    // Render these invisible elements so the fetches execute earlier.
    getStaticInvisibleElements() {
        const merchant = iFrameMerchantService.getMerchant();

        // This is so that the elements are under no circumstance visible.
        return (
            <div style={{opacity: 0, pointerEvents: "none", zIndex: -1, position: "absolute", top: -1e4, left: -1e4}}>
                {merchant && <Image src={merchant.wideLogoUrl}/>}
                <div style={{fontStyle: "italic"}}>a</div>
                <div style={{fontWeight: Theme.props.MERCHANT_FONT_WEIGHT_BOLD}}>a</div>
                <div>a</div>
            </div>
        );
    }

    getSubroutes() {
        const getAuthPage = (...args) => {
            if (iFrameState.authSocialProviders.indexOf(SOCIAL_APPS.CDS) !== -1) {
                return new CDSAuthPage(...args);
            }
            if (iFrameState.isInlineDonationFlow()) {
                return new DonationAuthPage(...args);
            }
            if (iFrameState.isInlineSubscriptionFlow()) {
                return new SubscribeAuthPage(...args);
            }

            return new AuthPanelPage(...args);
        };

        const buildRoute = (route, pageClass, options={doNotCache: true}) => new Route([route], pageClass, [], options);

        return [
            buildRoute(FUNCTIONALITY_NOT_ENABLED_URL, FunctionalityNotEnabledPanel),

            buildRoute(LOGIN_URL, getAuthPage),
            buildRoute(LOGIN_WITH_EMAIL_CODE_URL, EmailCodeConfirmationPanel),

            buildRoute(CTA_URL, CustomContentPanel), // TODO @branch WTF is this shit?

            buildRoute(PANEL_TYPE.empty, PanelCollapsed),

            buildRoute(INLINE_NEWSLETTER_URLS.subscribe, NewsletterSubscribePanel),
            buildRoute(INLINE_NEWSLETTER_URLS.success, NewsletterSubscribeSuccessPanel),

            buildRoute(INLINE_DONATION_URLS.donate, DonatePanel),
            buildRoute(INLINE_DONATION_URLS.paymentAndDonate, PaymentAndDonationPanel),
            buildRoute(INLINE_DONATION_URLS.thankYou, DonationSuccessPanel),

            buildRoute(INLINE_EDIT_DONATION_URLS.donate, EditDonationPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.thankYou, EditDonationSuccessPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.cancel, CancelDonationPanel),
            buildRoute(INLINE_EDIT_DONATION_URLS.cancelSuccess, DonationCanceledPanel),

            buildRoute(INLINE_SUBSCRIPTION_URLS.subscriptionCheckout, SubscribeReviewOrderPanel),
            buildRoute(INLINE_SUBSCRIPTION_URLS.subscribeThankYou, SubscribeSuccessPanel),

            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.giftDetails, GiftSubscriptionDetailsPanel),
            buildRoute(INLINE_GIFT_SUBSCRIPTION_URLS.success, GiftSubscriptionSuccessPanel),

            buildRoute(INLINE_SUBSCRIPTION_URLS.subscriptionManageInline, ManageSubscriptionPanel),

            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancel, EditSubscriptionCancelPanel),
            buildRoute(INLINE_EDIT_SUBSCRIPTION_URLS.cancelSuccess, EditSubscriptionCancelSuccessPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm, EditSubscriptionConfirmPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess, EditSubscriptionSuccessPanel),

            buildRoute(INLINE_USER_DASHBOARD_URLS.home, InlineUserDashboard),
            buildRoute(INLINE_USER_DASHBOARD_URLS.removeCard, InlineUserDashboardRemoveCardPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.removeAddress, InlineUserDashboardRemoveAddressPanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.addressInUsage, InlineUserDashboardAddressInUsePanel),
            buildRoute(INLINE_USER_DASHBOARD_URLS.changeEmailConfirmationCode, InlineUserDashboardChangeEmailCodeConfirmPanel),

            buildRoute(INLINE_SHOP_URLS.products, ShopPanel),
            buildRoute(INLINE_SHOP_URLS.reviewOrder, ShopReviewOrderPanel),
            buildRoute(INLINE_SHOP_URLS.orderSuccess, ShopOrderSuccessPanel),

            buildRoute(SUBSCRIPTION_PLAN_PANEL_URL, SubscriptionPlanPanel),
            buildRoute(PAYMENT_DETAILS_PANEL_URL, PaymentMethodPanel),
            buildRoute(PAYMENT_FAILED_PANEL_URL, PaymentFailedPanel),
            buildRoute(ADDRESS_PANEL_URL, AddressPanel),
        ];
    }

    getRoutes() {
        return new Route([], null, this.getSubroutes(), {});
    }

    preventScrollPropagation() {
        const node = document.documentElement;
        node.setAttribute("tabindex", 0);

        const scrollEventOptions = supportsPassiveEvents() ? {passive: false} : false;

        node.addEventListener("wheel", e => e.stopPropagation(), scrollEventOptions);
        node.addEventListener("touchmove", e => e.stopPropagation(), scrollEventOptions);
    }

    hideScrim() {
        this.redraw();
        Object.assign(document.documentElement.style, {
            background: "transparent",
        });
    }

    showScrim() {
        Object.assign(document.documentElement.style, {
            background: PanelAppGlobalStyleSheet.getInstance().themeProps.MERCHANT_SCRIM_BACKGROUND,
        });
    }

    onMount() {
        super.onMount();

        initializeFlows();

        addScrimListeners(IFRAME_APP_TYPE.panel);
        this.preventScrollPropagation();

        const checkPaymentRequestError = () => {
            const {paymentRequestStatus, panelType} = iFrameState;
            if (panelType === PANEL_TYPE.payment && authService.isAuthenticated()
                && paymentRequestStatus?.error?.panelLink) {
                Router.changeURL(paymentRequestStatus.error.panelLink);
            }
        };
        checkPaymentRequestError();

        this.attachUpdateListener(iFrameState, () => {
            this.applyMerchantConfig();
            checkPaymentRequestError();
            this.redraw();
        });

        if (iFrameState.gateType === GATE_TYPE.popup && Router.getCurrentPath() !== "/" + PANEL_TYPE.empty) {
            this.showScrim();
        }

        iFrameConnection.addListener(IFrameMessages.ROUTE_CHANGE, ({url}) => {
            if (url) {
                Router.changeURL(url);
            } else {
                // If the page is undefined, it will be handled inside the flow logic.
            }
            // Order matters. We need the router paths to be correct.
            if (url === PANEL_TYPE.empty) {
                this.hideScrim();
            } else if (iFrameState.gateType === GATE_TYPE.popup) {
                this.showScrim();
            }
        });

        // Expose these for debugging. Not exposed directly on window to not allow code to work without proper imports.
        window.PanelDebug = {
            Flow,
            Router,
            iFrameState,
        }
    }
}
